import {
  GET_PAGE_TITLE,
  GET_NAVIGATION_CONTENTS,
  SET_NAVIGATION_MENU_BACKGROUND,
  SET_NAVIGATION_PAGINATION,
  GET_ARTICLE_CARDS,
  GET_HOMEPAGE_POSTERS,
  SET_ARTICLE_CARDS_LOADED,
  SET_IS_TRANSPORTED,
  SET_NAVIGATION_MENU_HIDDEN,
  SET_ARTICLE_CATEGORY,
  SET_ARTICLE_POSTDATE,
  SET_HOMEPAGE_HEADER_OFFSET,
  SET_CATEGORY_FILTER,
  SET_HOMEPAGE_POSTERS_QUERY_VARS,
  SET_PREVIOUS_ARTICLE_FOCUS
} from './actionTypes';

const getPageTitle = (data, state) => ({
  ...state,
  pageTitle: data
});

const getNavigationContents = (data, state) => ({
  ...state,
  navContents: data
});

const setNavigationMenuBackground = (data, state) => ({
  ...state,
  navMenuBackground: data
});

const setNavigationPagination = (data, state) => ({
  ...state,
  navPagination: data
});

const getArticleCards = (data, state) => ({
  ...state,
  articleCards: data
});

const getHomepagePosters = (data, state) => ({
  ...state,
  homepagePosters: data
});

export default (state, action) => {
  switch (action.type) {
    case GET_PAGE_TITLE:
      return getPageTitle(action.payload, state);
    case GET_NAVIGATION_CONTENTS:
      return getNavigationContents(action.payload, state);
    case SET_NAVIGATION_MENU_BACKGROUND:
      return setNavigationMenuBackground(action.payload, state);
    case SET_NAVIGATION_PAGINATION:
      return setNavigationPagination(action.payload, state);
    case GET_ARTICLE_CARDS:
      return getArticleCards(action.payload, state);
    case GET_HOMEPAGE_POSTERS:
      return getHomepagePosters(action.payload, state);
    case SET_ARTICLE_CARDS_LOADED:
      return { ...state, isArticleCardsLoaded: action.payload };
    case SET_IS_TRANSPORTED:
      return { ...state, isTransported: action.payload };
    case SET_NAVIGATION_MENU_HIDDEN:
      return { ...state, navMenuHidden: action.payload };
    case SET_ARTICLE_CATEGORY:
      return { ...state, articleCategory: action.payload };
    case SET_ARTICLE_POSTDATE:
      return { ...state, articlePostdate: action.payload };
    case SET_HOMEPAGE_HEADER_OFFSET:
      return { ...state, homepageHeaderOffset: action.payload };
    case SET_CATEGORY_FILTER:
      return { ...state, categoryFilter: action.payload };
    case SET_HOMEPAGE_POSTERS_QUERY_VARS:
      return { ...state, homePagePosterQueryVars: action.payload };
    case SET_PREVIOUS_ARTICLE_FOCUS:
      return { ...state, previousArticleFocus: action.payload };

    default:
      return state;
  }
};
